import { render, staticRenderFns } from "./ProductdetailsPage.vue?vue&type=template&id=49ba1816"
import script from "./ProductdetailsPage.vue?vue&type=script&lang=js"
export * from "./ProductdetailsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports